import React, { FC } from 'react';
import { useApplication } from '../../../../context/ApplicationContext';
import { get } from 'lodash';
import { Breadcrumbs, Typography } from '@mui/material';
import Schema from '../../../../lib/paths/verwendungsnachweis_FULL_Paths.json';
const P = Schema.attributes;

const BreadCrumbVerwendungsnachweis: FC<{}> = () => {
	const { application } = useApplication();

	return (
		<>
			<Breadcrumbs separator="›" aria-label="breadcrumb" sx={{ maxWidth: '81.875rem', marginTop: '0.75rem', marginBottom: '2rem' }}>
				<Typography color="text.secondary">Mein Bereich</Typography>
				<Typography color="text.secondary">Meine Anträge</Typography>
				<Typography color="text.secondary">Verwendungsnachweis</Typography>
				<Typography color="primary">
					{get(application, P.Allgemein_Verwendungsnachweis_Vom.path, '')
						? `Vom: ${new Date(get(application, P.Allgemein_Verwendungsnachweis_Vom.path, '')).getFullYear()}`
						: '*'}
				</Typography>
			</Breadcrumbs>
		</>
	);
};

export default BreadCrumbVerwendungsnachweis;
